import { useActivityTracker } from '@/hooks/useActivityTracker';

/**
 * Invisible component that tracks user activity for re-engagement reminders.
 * Place inside AuthProvider.
 */
export function ActivityTracker() {
  useActivityTracker();
  return null;
}
